import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, formatMoney, getInlineLoader } from "../Helpers";
import {
  STR_NO_SERVICES_FOUND,
  STR_SEND_LAND_INQUIRY,
  STR_SUBMIT,
} from "../Strings";
import NapaAddressPicker from "../ones/NapaAddressPicker";

export default function ContactUs(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

		const [userLocation, setUserLocation] = useState({});
		const [services, setServices] = useState([]);
		const [serviceQuotes, setServiceQuotes] = useState([]);
	const [userPhone, setUserPhone] = useState(String(appContext?.currentUserData?.phone || ""));
	const [userFullname, setUserFullname] = useState(appContext?.currentUserData?.fullname || '' );

	async function init() {
		//run initializations here
		setReady(false);
			await callApi("get-service-quotes", {
				cornerPoints: JSON.stringify(appContext.selectedCornerPoints || []),
			}).then((response) => {
				if (response.status === 1) setServiceQuotes(response.data.services || []);
				else appContext.tellError(response.msg);
			});
		setReady(true);
	}

		function isServiceSelected(serviceData) {
			return services.includes(serviceData.uuid);
		}

	function toggleSelectedService(serviceData) {
			setServices((previous) => previous.includes(serviceData.uuid)
				? previous.filter((uuid) => uuid !== serviceData.uuid)
				: [...previous, serviceData.uuid]);
	}

	function openCreatedOrder(orderUuid) {
		const normalizedOrderUuid = String(orderUuid || '').trim();

		if (!normalizedOrderUuid) {
			appContext.tellError('Inquiry created but its reference could not be loaded');
			return;
		}

		appContext.navTo({
			item: 'view',
			subItem: 'order',
			extraItem: normalizedOrderUuid,
		})
	}

		async function createOrder() {
			const normalizedPhone = String(userPhone).replace(/\s+/g, "").trim();

			if(appContext.selectedCornerPoints && appContext.selectedCornerPoints.length >= 2) {
				if(normalizedPhone.length === 12 && normalizedPhone.startsWith("255")) {
				if(userFullname && userFullname.trim().length > 0) {
					if(userLocation && userLocation.region && userLocation.district && userLocation.street && userLocation.ward) {
						if(services.length > 0) {
							setLoading(true);
							await callApi(
								'create-order',
								{
									cornerPoints: JSON.stringify(appContext.selectedCornerPoints),
									pointsMappingMethod: appContext.pointsMappingMethod,
									pointsCrsMetadata: JSON.stringify(appContext.pointsCrsMetadata || {}),
									originalCornerPoints: JSON.stringify(appContext.originalCornerPoints || []),
										userPhone: normalizedPhone,
									userLocation: JSON.stringify(userLocation),
									userFullname,
									serviceUuids: JSON.stringify(services),

								}
							).then(response => {
								if(response.status === 1) {
									openCreatedOrder(response.data);
								} else {
									appContext.tellError(response.msg);
								}
							})
							setLoading(false);
						} else {
							appContext.tellError("Please select atleast one service");
						}
					} else {
						appContext.tellError("Invalid Current location, please select region, district, ward and street")
					}
				} else {
					appContext.tellError("Invalid fullname")
				}
			} else {
				appContext.tellError("Invalid Phone number")
			}
		} else {
			appContext.tellError("Invalid Land Corner Points");
		}
	}

	useEffect(() => {
		init();
	}, [])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])


	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						<div className="col-md-12">
							<div className="row" style={{ marginTop: "10px", marginBottom: "30px", }}>

								<div className="col-md-12">
									<h6
										className="main-section-title"
									>
											{STR_SEND_LAND_INQUIRY[appContext.language]}
									</h6>
								</div>

								<>
										<div
											className="col-12 mt-2 mb-2"
										>
											<label className="form-label">Current Location</label>
											<NapaAddressPicker callback={setUserLocation}/>
										</div>

										<div
											className="col-12 mt-2 mb-2"
										>
											<label className="form-label">Your Phone Number</label>
											<input
												className="form-control"
											value={userPhone}
											maxLength={12}
											onChange={(e) => setUserPhone(e.target.value)}
											/>
											<div className="form-text">Include country code, eg 255XXXXXXXXX</div>
										</div>

										<div
											className="col-12 mt-2 mb-2"
										>
											<label className="form-label">Your Fullname</label>
											<input
												className="form-control"
												value={userFullname}
												onChange={(e) => setUserFullname(e.target.value)}
											/>
										</div>

										<div
											className="col-12 mt-2 mb-2"
										>
											<label className="form-label">Select Services You Need</label>
											{
											(serviceQuotes.length > 0) ?
											serviceQuotes.map((item) => {
													return (
														<div
															className={(isServiceSelected(item)) ? "card bg-secondary" : "card"}
											key={item.uuid || item.id}
															style={{
																cursor: "pointer",
															}}
															onClick={() => {
																toggleSelectedService(item)
															}}
														>
															<div className="card-body">
																<h6
																	className="font-semi-bold"
																	style={{
																	fontSize: "24px"
																	}}
																>
												{appContext.language === 'sw' ? (item.titleSw || item.titleEn) : item.titleEn}
																</h6>

																<h6
																	className="font-light mt-3 text-end"
																	style={{
																	fontSize: "20px"
																	}}
																>
															TZS {formatMoney(item.quote?.quotedAmount)}
														</h6>
														<p className="text-muted text-end mb-0" style={{ fontSize: "12px" }}>
															{item.pricingType === 'variable'
																? `${formatMoney(item.quote?.measurementQuantity)} ${item.unit} ÷ ${formatMoney(item.unitSize)} × TZS ${formatMoney(item.unitPrice)}`
																: 'Fixed fee'}
														</p>
														<p className="text-muted text-end" style={{ fontSize: "12px" }}>
															{item.paymentRequirement === 'down_payment'
																? `${item.downPaymentPercent}% down payment: TZS ${formatMoney(item.quote?.amountRequiredToStart)}`
																: 'Full payment required to start'}
														</p>

															</div>
														</div>
													)
												})
												:
											<h6>{STR_NO_SERVICES_FOUND[appContext.language]}</h6>
											}
											
										</div>

										<div
											className="col-12 mt-2 mb-2"
										>
											<button
												className="btn btn-block btn-dark btn-rounded btn-padded"
												style={{
													textTransform: "uppercase",
												}}
												onClick={createOrder}
											>
												{STR_SUBMIT[appContext.language]}
											</button>
										</div>
									
								</>

							</div>
						</div>



					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}
